module.exports = __webpack_public_path__ + "img/conference_hall_2.b27a64a7.jpg";